import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Card } from '../components/ui/card';
import { MapPin, Mail } from 'lucide-react';

const Contact = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-[#021F3F] via-[#0A3D62] to-[#021F3F]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            {t.contact.title}
          </h1>
          <p className="text-xl text-gray-300 mb-8">
            {t.contact.subtitle}
          </p>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto" />
        </div>
      </section>

      {/* Introduction Section */}
      <section className="py-12 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            {t.contact.introText}
          </p>
          <p className="text-base text-gray-600 leading-relaxed">
            {t.contact.availabilityText}
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-[#F8F8F8]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Contact Information */}
            <div className="space-y-8">
              <Card className="p-8 border-none shadow-lg hover:shadow-xl transition-shadow duration-300">
                <div className="flex items-start space-x-4">
                  <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#D4AF37] to-[#E6C76D] flex items-center justify-center flex-shrink-0">
                    <MapPin className="text-[#021F3F]" size={24} />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#021F3F] mb-2">
                      {t.contact.info.company}
                    </h3>
                    <p className="text-gray-600">{t.contact.info.location}</p>
                  </div>
                </div>
              </Card>

              <Card className="p-8 border-none shadow-lg hover:shadow-xl transition-shadow duration-300">
                <div className="flex items-start space-x-4">
                  <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#D4AF37] to-[#E6C76D] flex items-center justify-center flex-shrink-0">
                    <Mail className="text-[#021F3F]" size={24} />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#021F3F] mb-2">Email</h3>
                    <a
                      href={`mailto:${t.contact.info.email}`}
                      className="text-gray-600 hover:text-[#0A3D62] transition-colors"
                    >
                      {t.contact.info.email}
                    </a>
                  </div>
                </div>
              </Card>

              {/* Map Placeholder */}
              <Card className="p-8 border-none shadow-lg overflow-hidden">
                <div className="bg-gradient-to-br from-[#021F3F] to-[#0A3D62] rounded-lg p-12 text-center">
                  <MapPin className="text-[#D4AF37] mx-auto mb-4" size={48} />
                  <h3 className="text-2xl font-bold text-white mb-2">
                    Dubai, UAE
                  </h3>
                  <p className="text-gray-300">
                    {t.contact.info.company}
                  </p>
                </div>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;